/* 
JKwan 20210712 - check if all cart items are 'geovalid' (come from the same city) and show warnings as applicable (header cart icon, mini-cart, cart page)
*/

// Check if all cart items are 'geovalid'
async function isCartGeoValid() {
  try {       
  	const myRequest = new Request('/cart.js', { 
      method: 'GET',
      headers: {'Content-Type': 'application/json'} });
    
    const response = await fetch(myRequest);
    const data = await response.json();
    const items = await data.items;
    const itemsCityCodeArray = [ ];

    for(let i=0, j=items.length; i<j; i++) {        
      let itemSku = items[i].sku.toLowerCase();
      let itemCityCode = itemSku.slice(itemSku.length - 3);
      itemsCityCodeArray.push(itemCityCode);
    }

    let isCartValid = itemsCityCodeArray.every( (cityCode, i, array) => cityCode === array[0] );
//     console.log('jkwan isCartValid: ' + isCartValid);
    return isCartValid;
    
//     fetch(myRequest)
//       .then(response => response.json())
//       .then(data => {
//       	let items = data.items;
//         const itemsCityCodeArray = [ ];

//         for(let i=0, j=items.length; i<j; i++) {        
//           let itemSku = items[i].sku.toLowerCase();
//           let itemCityCode = itemSku.slice(itemSku.length - 3);
//           itemsCityCodeArray.push(itemCityCode);        
//         }
//       console.log('itemsCityCodeArray:')
//       console.log(itemsCityCodeArray);
//       console.log(itemsCityCodeArray[0]);
//       	//let firstCityCode = itemsCityCodeArray[0];
//       	// If the SKU ending of every cart item matches, assume cart is geovalid
//       	// Down the road, if we have multi-city or global or digital items, we can add complexity to this logic here
//         let isCartValid = itemsCityCodeArray.every( (cityCode, i, array) => cityCode === array[0] );//cityCode => cityCode === firstCityCode );
//       console.log('jkwan isCartValid: ' + isCartValid);
//         return isCartValid;
//       })
//       .catch(console.error);
    
  } catch(error) {
    console.log(error);
  }
}



// Conditionally show orange warning badge on header cart icon
async function updateCartIconWarning() {
  let isCartGeoValidReturn = await isCartGeoValid();

  if (isCartGeoValidReturn) {
    $('.header-cart__count--badge').removeClass('isCartGeoValid-cartIcon');
  } else {
    $('.header-cart__count--badge').addClass('isCartGeoValid-cartIcon');
    $('.header-cart__count--badge').text('!');
  }
}

// Conditionally show text error message in mini-cart
async function updateMiniCartWarning() {
  let isCartGeoValidReturn = await isCartGeoValid();

  if (isCartGeoValidReturn) { 
    $('.isCartGeoValid-miniCart').hide(); 
  } else {
    $('.isCartGeoValid-miniCart').show();
  }
}

// Conditionally show detailed text error message on cart page
async function updateCartPageWarning() {  
  if (window.location.pathname == '/cart') {  //if path STARTS WITH /cart... 
    let isCartGeoValidReturn = await isCartGeoValid();

    if (isCartGeoValidReturn) { 
      $('.isCartGeoValid-cartPage').hide();
    } else {
      $('.isCartGeoValid-cartPage').show();
    }
  }
}


// Conditionally show all three types of error messages upon page load
// functions now called in initializeAjaxCart of jsAjaxCart.js
// $(document).on('ready', function() {
//   updateCartIconWarning(); 
//   updateMiniCartWarning();
//   updateCartPageWarning();
// })
